const NAME =  'gama-secondhand'
const VERSION = '1.0.0'

const SELECTOR_BUTON_ORDER = ".btn-order"
const EVENT_CLICK = "click"

class GamaSecondhand {
  constructor(el) {
    el.addEventListener(EVENT_CLICK, this.submitOrder)

  }
  static get NAME() {
    return NAME
  }

  static get VERSION() {
    return VERSION
  }

  submitOrder(event) {
    event.preventDefault();
    console.log("clicked", event)
  }

}

const orderBtn = document.querySelector(SELECTOR_BUTON_ORDER)
if (orderBtn) {
  new Secondhand(orderBtn)

}

export default GamaSecondhand
